// @flow
import { MAP_LAYER_DRAWER_TOGGLE } from 'actions/mapLayerDrawer';

const INITIAL_STATE = {
  open: false,
};

export default function reduce(state = INITIAL_STATE, { type, open }) {
  switch (type) {
    case MAP_LAYER_DRAWER_TOGGLE:
      return {
        ...state,
        open,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/mapLayerDrawer.js